<template>
  <v-container class="fill-height" style="display: block;" fluid>
    <v-window v-model="windowPage" style="width: 100%;" touchless>

        <v-window-item :key="0">
            <div id="ag-grid-container">
                <ag-grid-vue style="width: 100%; height: 100%;" class="ag-theme-balham" v-if="showGrid"
                    :gridOptions="gridOptions"
                    @row-double-clicked="(params) => editTree(params.data)"
                    :groupHeaders="true"
                    :rowHeight="40">
                </ag-grid-vue>
            </div>
            <v-btn color="#c42111" class="mt-3 mr-3" @click="newTree" :disabled="lockSave" v-if="showGrid">New</v-btn>
        </v-window-item>

        <v-window-item :key="1">
            <tree-structure v-if="windowPage == 1" :tree="selectedTree" :lockSave="lockSave" @cancel="onTreeStructureCancel" @save="saveTreeStructureClick"></tree-structure>
        </v-window-item>

        <v-dialog v-model="showTreeEdit" max-width="80%" width="300px" persistent>
            <tree-edit :tree="selectedTree" v-if="showTreeEdit" @save="saveTree" @cancel="showTreeEdit = false"></tree-edit>
        </v-dialog>
    
    </v-window>
  </v-container>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
import TreeEdit from "@/components/Trees/TreeEdit";
import TreeStructure from "@/components/Trees/TreeStructure";
export default {
    name: 'Trees',
    props: [''],
    components: {
        'ag-grid-vue': AgGridVue,
        TreeEdit,
        TreeStructure
    },
    data: () => ({
        showGrid: false,
        windowPage: 0,
        lockSave: false,
        treesList: [],
        showTreeEdit: false,
        selectedTree: null,
    }),

    computed: {

    },

    methods: {
        getTreesList: function() {
            this.showGrid = false;
            let route = (TELSA.apiHost + "trees/list");
            TELSA.loading(true);
            return this.$http.get(route).then(response => {
                let result = response.body;
                this.treesList = result.trees;
                this.buildAgGrid();
                TELSA.loading(false);
            });
        },

        buildAgGrid: function() {
            this.showGrid = false;
            this.gridOptions = {};
            this.gridOptions.rowData = this.treesList;
            this.gridOptions.columnDefs = this.createColumnDefs();
            let self = this;
            this.gridOptions.onGridReady = function(params) {
                self.gridOptions.api.hideOverlay();
                //self.gridOptions.columnApi.autoSizeColumns();
                self.gridOptions.api.sizeColumnsToFit();
            }

            this.gridOptions.getContextMenuItems = function() {
                return [
                    'copy',
                    'copyWithHeaders',
                    'paste',
                    'csvExport',
                    'excelExport',
                    {
                        name: 'AI Analyser',
                        disabled: !self.$store.state.batchConfig.webapp_openai,
                        action: function() {
                            self.$store.commit('setAiAnalyzerContext', 'trees');
                            self.$store.commit('setAiAnalyzerGridAPI', self.gridOptions.api);
                            self.$store.commit('setShowAIAnalyzer', true);
                        },
                        icon: `<i data-v-10101010101="" aria-hidden="true" class="v-icon notranslate mdi mdi-lightning-bolt theme--dark"></i>`
                    },
                ];
            };

            this.gridOptions.defaultColDef = {
                sortable: true,
                filter: true,
                resizable: true
            }
            this.showGrid = true;
        },

        createColumnDefs: function() {
            let columnDefs = [];
            const self = this;
            columnDefs = [
                { 
                    headerName: '', 
                    suppressSizeToFit: true,
                    width: 120, filter: 'text', cellStyle: {'padding-top': '5px', 'text-align': 'left', 'background-color': 'white', 'border-right': 'black solid 1px'},
                    cellRenderer: class {
                        init(params) {
                            this.params = params;
                            this.eGui = document.createElement('div');
                            this.eGui.innerHTML = `<span class="mdi mdi-pencil-circle tree-action" style="cursor: ${self.lockSave ? 'default' : 'pointer'}; color: ${self.lockSave ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />
                                <span class="mdi mdi-delete-circle tree-action" style="cursor: ${self.lockSave ? 'default' : 'pointer'}; color: ${self.lockSave ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />
                                <span title="Edit Structure" class="mdi mdi-file-tree tree-action" style="cursor: pointer; color: #c42111; font-size: 20pt" />`;
                            
                            this.editButtonHandler = this.editButtonHandler.bind(this);
                            this.deleteButtonHandler = this.deleteButtonHandler.bind(this);
                            this.structureButtonHandler = this.structureButtonHandler.bind(this);

                            this.editButton = this.eGui.querySelectorAll('.tree-action')[0];
                            this.deleteButton = this.eGui.querySelectorAll('.tree-action')[1];
                            this.structureButton = this.eGui.querySelectorAll('.tree-action')[2];

                            this.editButton.addEventListener('click', this.editButtonHandler);
                            this.deleteButton.addEventListener('click', this.deleteButtonHandler);
                            this.structureButton.addEventListener('click', this.structureButtonHandler);
                        }
                        getGui() {
                            return this.eGui;
                        }
                        editButtonHandler(event) {
                            event.stopPropagation();
                            this.params.editFunction(this.params);
                        }
                        deleteButtonHandler(event) {
                            event.stopPropagation();
                            this.params.deleteFunction(this.params);
                        }
                        structureButtonHandler(event) {
                            event.stopPropagation();
                            this.params.structureFunction(this.params);
                        }
                        destroy() {
                            this.editButton.removeEventListener('click', this.editButtonHandler);
                            this.deleteButton.removeEventListener('click', this.deleteButtonHandler);
                            this.structureButton.removeEventListener('click', this.structureButtonHandler);
                        }
                    },
                    cellRendererParams: {
                        editFunction: (params) => {
                            if(!self.lockSave) {
                                this.editTree(params.data);
                            }
                        },
                        deleteFunction: (params) => {
                            if(!self.lockSave) {
                                this.deleteTreeClick(params.data);
                            }
                        },
                        structureFunction: (params) => {
                            this.editTreeStructure(params.data);
                        }
                    }
                },
                { 
                    headerName: 'Tree Name', 
                    field: 'tree_name', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Description', 
                    field: 'tree_description', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Leaves', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    field: 'tree_leaves',
                },
            ];
            return columnDefs;
        },

        editTree: function(tree) {
            if(this.lockSave) {
                return;
            }
            let treeClone = JSON.parse(JSON.stringify(tree));
            this.selectedTree = treeClone;
            this.showTreeEdit = true;
        },

        saveTree: function(tree) {
            TELSA.loading(true);
            let route = (TELSA.apiHost + "trees/edit");
            if(tree.tree_id == 0) {
                route = (TELSA.apiHost + "trees/add");
            }
            this.$http.post(route, {args: {tree: tree}}).then(response => {
                let result = response.body;
                this.showTreeEdit = false;
                this.$store.commit('setIsDirty', false);
                this.windowPage = 0;
                this.getTreesList();
            });
        },

        deleteTreeClick: function(tree) {
            this.$store.commit('showConfirmModal', {
                title: 'Delete Tree',
                message: `This operation will delete this tree, and remove this tree from all sites. Are you sure you want to do this?`,
                type: 'delete',
                hideCancel: false,
                confirmAction: () => this.deleteTree(tree)
            });
        },

        deleteTree: function(tree) {
            TELSA.loading(true);
            let route = (TELSA.apiHost + "trees/delete");
            this.$http.post(route, {args: {treeId: tree.tree_id}}).then(response => {
                let result = response.body;
                this.getTreesList();
            });
        },

        newTree: function() {
            this.selectedTree = {
                tree_id: 0,
                tree_description: '',
                tree_name: ''
            };
            this.showTreeEdit = true;
        },

        editTreeStructure: function(tree) {
            let treeClone = JSON.parse(JSON.stringify(tree));

            // Attach a children list to each node
            let nodeList = treeClone.tree_structure;
            nodeList.forEach(n => {
                n.children = [];
            });

            // Recursively search for the parent node
            let getNodeParent = function(node, items) {
                for(let item of items) {
                    if(node.parent_node_id == item.node_id) {
                        return item;
                    }
                    if(item.children.length) {
                        let value = getNodeParent(node, item.children);
                        if(value) {
                            return value;
                        }
                    }
                }
            }

            let done = false;
            let i = 0;
            while(!done) {
                done = true;
                i = 0;
                for(i; i < nodeList.length; i++) {
                    if(nodeList[i].parent_node_id != -1) {
                        done = false;
                        let parentItem = getNodeParent(nodeList[i], nodeList);
                        parentItem.children.push(nodeList[i]);
                        nodeList.splice(i, 1);
                        break;
                    }
                }
            }

            treeClone.tree_structure = {
                node_description: '',
                node_id: -1,
                node_line_height: 0,
                node_name: 'Site',
                tree_id: treeClone.tree_id,
                children: treeClone.tree_structure
            };
            this.selectedTree = treeClone;
            this.windowPage = 1;
        },

        convertTreeStructureToArray: function() {
            let treeNodes = [];
            let treeStructure = this.selectedTree.tree_structure;
            let rec = function(nodes) {
                nodes.forEach(n => {
                    treeNodes.push(n);
                    if(n.children.length) {
                        rec(n.children);
                    }
                });
            };
            rec(treeStructure.children);
            return treeNodes;
        },

        saveTreeStructureClick: function(deletedNodes) {
            this.$store.commit('showConfirmModal', {
                title: 'Are you sure?',
                message: 'Are you sure you want to commit your changes?',
                type: '',
                confirmAction: () => {this.saveTreeStructure(deletedNodes);}
            });
        },

        saveTreeStructure: function(deletedNodes) {
            TELSA.loading(true);
            // Build list of nodes. Start with all the active ones, then add on the deleted ones at the end of the list.
            let treeNodes = this.convertTreeStructureToArray();
            treeNodes = treeNodes.concat(deletedNodes);
            treeNodes.forEach(n => {
                if('children' in n) {
                    delete n.children;
                }
            });
            
            let route = (TELSA.apiHost + "trees/nodes");
            this.$http.post(route, {args: {treeNodes: treeNodes}}).then(response => {
                let result = response.body;
                this.$store.commit('setIsDirty', false);
                this.windowPage = 0;
                this.getTreesList(); 
            });
        },

        onTreeStructureCancel: function() {
            if(this.$store.state.isDirty) {
                this.$store.commit('showConfirmModal', {
                    title: 'Are you sure?',
                    message: 'Are you sure you want to abandon your changes without saving?',
                    type: 'warning',
                    confirmAction: () => {this.$store.commit('setIsDirty', false); this.windowPage = 0;}
                });
            }
            else {
                this.windowPage = 0;
            }
        },


    },

    mounted() {
        // Permissions Check
        let permission = TELSA.checkPermission(this.$store.state.user, 'admin/sitebook');
        if(!permission) {
            let self = this;
            this.$store.commit('insufficientPermissions', {
                confirmAction: function(){self.getTreesList()}
            });
            this.lockSave = true;
            return;
        }

        let lockName = `edit_sitebook`;
        this.$store.dispatch('getLock', lockName).then(lockOwner => {
            this.getTreesList().then(v => {
            if(lockOwner) {
                // Disable save and let user know page is locked!
                this.lockSave = true;
                this.$store.commit('showConfirmModal', {
                title: 'Lock Warning',
                message: `The Site Book is already locked for editing by <font color="#FB8C00"><b>${lockOwner}</b></font>. You cannot save any changes at this time.`,
                type: 'warning',
                hideCancel: true,
                confirmAction: function(){}
                });
            }
            });
        });
    }

  
};
</script>

<style scoped>
    .data-container {
        display: block;
        padding: 0;
    }

    #ag-grid-container {
        height: calc(100vh - 126px);
    }

</style>
